module.exports = __webpack_public_path__ + "img/light-mud-decal-15.cdd62f6c.png";